import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'tog-inner-left-nav',
  templateUrl: 'inner-left-nav.template.html',
  styleUrls: ['inner-left-nav.scss']
})
export class InnerLeftNavComponent implements OnInit, OnDestroy {
  togRootEl: Element;
  collapsed: boolean = false;
  @Input() collapsible: boolean;

  ngOnInit() {
    this.togRootEl = (<HTMLDivElement>document.getElementsByClassName('tog-root-content')[0]);
    if (this.togRootEl) this.togRootEl.classList.add('has-inner-left-nav');
  }

  ngOnDestroy() {
    if (this.togRootEl) {
      this.togRootEl.classList.remove('has-inner-left-nav');
      this.togRootEl.classList.remove('has-collapsed-inner-left-nav');
    }
  }

  collapse() {
    this.collapsed = !this.collapsed;
    if(this.collapsed) {
      setTimeout((self) => {
        self.togRootEl.classList.add('has-collapsed-inner-left-nav');
        self.togRootEl.classList.remove('has-inner-left-nav');
      }, 100, this);
    }
    else {
      this.togRootEl.classList.remove('has-collapsed-inner-left-nav');
      this.togRootEl.classList.add('has-inner-left-nav');
    }
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/components/inner-left-nav/inner-left-nav.component.ts